// extracted by mini-css-extract-plugin
export default {"catalogWrapper":"u1Wum","catalog":"piEXQ"};